import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import Link from '../../../components/Link';
import { getAppDetail } from '../reducers/apps/details';
import { updateAppSubmit } from '../actions/editApp';
import { removeNulls } from '../../../utils/helpers';
import { filterNotAllowedFields } from '../models/EditAppForm';
import EditAppForm, { FORM_ID as EditAppFormId } from '../components/apps/EditAppFormCreator';
import EditAppIconForm, { FORM_ID as EditAppIconFormId } from '../components/apps/EditAppIconForm';
import { uploadAppIcon } from '../actions/editAppIcon';
import { routes } from '../../../routesConstants';

class AppEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
      uploadLink: null,
    });
  }

  render() {
    const {
      app,
      editAppFormStore,
      editAppIconFormStore,
      updateAppSubmitFn,
      uploadAppIconFn,
    } = this.props;
    return (
      <div className="container">
        <Link to={`${routes.ROUTE_HOME_COMPONENTS}/${app.id}`}>&larr; Go to component detail</Link>
        <EditAppForm
          formId={EditAppFormId}
          module="home"
          app={app}
          initialValues={removeNulls(filterNotAllowedFields(app))}
          formStore={editAppFormStore}
          updateAppSubmitFn={updateAppSubmitFn}
          showModal={this.state.showModal}
          editAppIconOpenModalFn={this.openModal}
        />
        <EditAppIconForm
          app={app}
          uploadAppIconFn={uploadAppIconFn}
          formStore={editAppIconFormStore}
          showModal={this.state.showModal}
          editAppIconCloseModalFn={this.closeModal}
        />
      </div>
    );
  }
}

AppEdit.propTypes = {
  app: PropTypes.object.isRequired,
  editAppFormStore: PropTypes.object,
  editAppIconFormStore: PropTypes.object,
};

const editAppFormSelector = formValueSelector(EditAppFormId);
const editAppIconFormSelector = formValueSelector(EditAppIconFormId);

const mapStateToProps = (state, options) => {
  const { appId } = options.match.params;
  return {
    app: getAppDetail(state, appId),
    editAppFormStore: {
      defaultBucket: editAppFormSelector(state, 'defaultBucket'),
      actions: editAppFormSelector(state, 'actions'),
      logger: editAppFormSelector(state, 'logger'),
      longDescription: editAppFormSelector(state, 'longDescription'),
      uiOptions: editAppFormSelector(state, 'uiOptions'),
      configurationDescription: editAppFormSelector(state, 'configurationDescription'),
    },
    editAppIconFormStore: {
      file: editAppIconFormSelector(state, 'file'),
    },
  };
};

export default connect(mapStateToProps, {
  updateAppSubmitFn: updateAppSubmit,
  uploadAppIconFn: uploadAppIcon,
})(AppEdit);
